var ButtonShapeEnum;
(function (ButtonShapeEnum) {
    ButtonShapeEnum["circle"] = "circle";
    ButtonShapeEnum["round"] = "round";
})(ButtonShapeEnum || (ButtonShapeEnum = {}));

export { ButtonShapeEnum };
